import React from 'react';
/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

export const Goal15 = () => (
  <SVG
    width="50"
    height="50"
    viewBox="0 0 2250 2250"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path d="M2250,2250H0V0H2250Z" fill="#5ec336" />
    <Path
      d="M655.35,1264c-53.25-33.21-68.82-90.58-53.94-139.23,13.36-43.7,56-85.83,121.15-84C730,980,759.9,934.19,815.66,907.36c40.41-19.44,82.52-20.71,124.56-5.33,85,31.12,131.77,129.34,90,221.44,2.53.86,5,1.81,7.48,2.51,82.29,22.93,136.81,97.87,133,182.75s-66.39,156-151,169.44c-21.53,3.42-43.84,2.2-65.8,2.44-24.49.27-49-.22-73.49-.4q-67.85-.48-135.69-1c-61.28-.53-116.61-51.65-122.53-112.44-3.68-37.89,6.43-71.1,31.22-99.91C654,1266.12,654.5,1265.26,655.35,1264Z"
      fill="#fff"
    />
    <Path
      d="M1113.42,1848H569.7c-12.07,0-12.07,0-12.07-12.09q0-26.62,0-53.25c0-12.66,0-12.67,12.34-12.67H1656.66c12.55,0,12.55,0,12.55,12.53q0,27,0,54c0,11-.43,11.48-11.32,11.48Z"
      fill="#fff"
    />
    <Path
      d="M1113.52,1981.54H569.06c-11.42,0-11.43,0-11.44-11.11,0-19.25.16-38.5-.09-57.75-.08-6.36,2.12-9.49,8.69-8.93,1.49.12,3,0,4.5,0H1656.64c1.75,0,3.5.06,5.25,0,5-.17,7.37,2.06,7.35,7.15q-.1,31.88,0,63.75c0,4.57-1.91,7.08-6.74,6.88-2-.08-4,0-6,0Z"
      fill="#fff"
    />
    <Path
      d="M318.26,498.39h79.65c.81,10.9,1.25,21.57,2.52,32.14a102.37,102.37,0,0,0,4.4,19.64c3.85,11.72,12.44,17.61,24.72,18.35,12.91.78,24.25-3.06,28.61-15.69a139.08,139.08,0,0,0,7.29-37.13c1.68-29.65,3.2-59.46-3.44-88.83-4.17-18.44-12.47-26.74-27.47-28.09-16.94-1.52-28.36,5.58-35.85,22.29-.41.91-.84,1.81-1.2,2.74-5.26,13.76-5.26,13.76-20.35,13.76H322.61c2-81.64,3.9-162.88,5.86-244.59h198v70.57H396.37c-1.58,31.11-3.12,61.46-4.58,90.31,12.29-4.65,24.59-11.06,37.65-13.75a124.59,124.59,0,0,1,40.11-1.85c36.83,4.65,55.1,30.21,65.58,62.88s10.59,66.47,8.49,100.21A325.26,325.26,0,0,1,536.89,551c-10.76,48.75-41,74.57-90.85,78.51-20,1.57-40,1-59.53-4.18-30.71-8.21-50.91-27.26-59.91-58C320.08,545.06,318.76,522.23,318.26,498.39Z"
      fill="#fff"
    />
    <Path
      d="M271.09,192.56V622.62H188.92V278.79l-62.34,22.48V281.35c0-11.75.23-23.5-.11-35.24-.15-4.76,1.53-6.9,5.85-8.8,25.84-11.41,51.18-23.77,72.64-42.68,1.06-.93,2.53-2,3.81-2C229.46,192.52,250.15,192.56,271.09,192.56Z"
      fill="#fff"
    />
    <Path
      d="M1455,1340.55c19.41-14.61,41-26.33,65.57-31.82,45.49-10.2,84.27,3,117.55,34.48,5.07,4.81,5.72,14.43,1.79,19.15-3.72,4.49-9.49,3.24-17,.24-10.71-4.28-22.08-8.44-33.43-9.34-46.15-3.63-85.58,13-120.14,42.73-2.84,2.44-5.34,5.57-8.59,7.18-6.54,3.23-12.27,1.31-17.68-3.68-26.74-24.67-57.7-41-94.09-45.72-18-2.33-35.92-2.08-53.36,3.79a40.18,40.18,0,0,0-9.4,4.48c-5.38,3.59-10.8,6-16.24.81-4.32-4.15-3.36-16.15,1.51-20.68,15.18-14.11,32.27-25.17,52.22-31.34,35.49-11,69.13-4.8,101.36,11.76C1435.18,1327.82,1444.69,1334.34,1455,1340.55Z"
      fill="#fff"
    />
    <Path
      d="M858.13,1612.07c0-26.24.19-52.48-.12-78.71-.08-7.27,2.55-9.64,9.66-9.52q29.22.51,58.46,0c7.27-.12,9.64,2.75,9.62,9.73q-.24,78.35,0,156.68c0,6.45-1.94,9.51-9.08,9.38-20-.37-40-.32-60,0-6.62.1-8.71-2.41-8.65-8.82C858.27,1664.54,858.13,1638.3,858.13,1612.07Z"
      fill="#fff"
    />
    <Path
      d="M1307.51,1052.77c18.92-15.63,39.25-27.42,63.24-31.85,33.85-6.26,63.14,3.62,89,25.28,4.83,4,6.06,13.2,2.52,17.71-4.38,5.58-9.85,4.88-15.44,1.91-15.46-8.22-32-7.19-48.32-4.65-29.11,4.52-53.51,18.48-74.19,39.24-11.31,11.36-14.63,11.42-27.17,1.92-32.64-24.73-68.67-36.17-109.6-26.77a53.37,53.37,0,0,0-15.72,6.64c-7,4.3-12.22,5-16,.59s-3.66-14.16.71-18.74c16.44-17.21,35.72-29.63,59.58-33.71,31.72-5.42,60.25,3.58,87.1,19.8C1304.49,1050.92,1305.76,1051.71,1307.51,1052.77Z"
      fill="#fff"
    />
    <Path
      d="M1177,534.55v90.58h-26.13V461.06c6.25,0,12.42-.45,18.46.26,1.86.22,4,3.33,4.93,5.56,10.63,24.19,21,48.47,31.55,72.72a19,19,0,0,0,5.36,7.77V461c7.93,0,14.64-.28,21.29.21,1.51.11,3.89,2.79,4,4.45.51,5.7.21,11.47.21,17.22V625.59c-6,0-11.76.55-17.28-.28-2-.31-4.29-3.57-5.3-6-11.05-26.19-21.86-52.47-32.77-78.72-.9-2.17-2-4.26-3-6.39Z"
      fill="#fff"
    />
    <Path
      d="M809.93,544.13c-.84,15.92-.45,32-2.8,47.74-3.38,22.57-15.42,33.23-37.9,35.47a83.57,83.57,0,0,1-23-1c-16.79-3.05-27.39-15-30.65-33.53A107.78,107.78,0,0,1,714,575c-.18-22.73-.32-45.46,0-68.18.45-33,18.54-49.58,51.4-47.75,26.62,1.49,41.33,15.57,42.93,42.37.84,14.18.15,28.44.15,42.67Zm-31.8-1h-.59c0-15.47.73-31-.24-46.39-.7-11.09-6.68-15.49-16.6-15.12-9.67.37-14.2,4.91-15.5,15.66a64.18,64.18,0,0,0-.52,7.46q-.06,38.2,0,76.42a58.76,58.76,0,0,0,.92,11.17c1.85,9.43,8.28,13.87,17.9,12.76s14.29-7,14.55-20C778.34,571.07,778.13,557.08,778.13,543.09Z"
      fill="#fff"
    />
    <Path
      d="M1255.45,625.2V461.11c21.33.71,42.55-2.59,63.34,3.1,16.58,4.54,25.28,16.88,25.72,33,.85,31.14,1.15,62.4-.8,93.46-1.33,21-14.92,32.8-36,34.26C1290.57,626.15,1273.33,625.2,1255.45,625.2Zm30.32-21c4.7,0,8.94.38,13.09-.07,9.34-1,14.82-5.65,15-14.73q.74-45.67.14-91.36c-.13-9.48-5.27-13.91-14.61-14.89-4.37-.46-8.84-.08-13.59-.08Z"
      fill="#fff"
    />
    <Path
      d="M850.21,533.39V625H825.06V461.06c5.9,0,11.65-.44,17.25.24,2,.24,4.3,2.93,5.23,5.05,11.38,25.76,22.53,51.62,33.75,77.45a11.41,11.41,0,0,0,3.62,5.07V461.53h25v164c-5.54,0-11.24.46-16.78-.25-1.9-.24-4.1-3.13-5-5.29-11.54-27.33-22.87-54.74-34.26-82.13-.65-1.58-1.41-3.11-2.11-4.67Z"
      fill="#fff"
    />
    <Path
      d="M1427,892.05c29.14.18,51.47,14,69.66,35.48,3.86,4.55,6.83,5.4,12.49,3.75,34.19-10,65.81-6.59,92.07,20,5,5.1,9.11,11.23,13.14,17.22,4.23,6.28,3.23,14.74-1.58,18.32s-10,1.8-16.26-4c-10.68-10-24.22-13.55-38.25-15.33-19.87-2.52-38.72,1.45-56.84,9.6-13.2,5.93-15.7,5.11-23.67-7.33-16-24.94-37.86-41.56-67.52-46.57a48.76,48.76,0,0,0-15.52.38c-6.13,1-11.7,1.43-14.53-5.38-2.26-5.46,1.27-13.44,7.15-16.35C1399.83,895.61,1413,891.93,1427,892.05Z"
      fill="#fff"
    />
    <Path
      d="M1043.86,622.19c4.05-20.79,8-41.6,12.15-62.37,6.43-32,13-64,19.54-96a20.16,20.16,0,0,1,1.19-2.77c8.94,0,18.15-.3,27.31.27,1.73.11,4.26,3.5,4.72,5.73,8.54,41,16.83,82.06,25.16,123.11,2.33,11.48,4.62,23,7,35h-28.11c-2.15-11.82-4.35-24-6.66-36.69h-28.09c-2.15,11.81-4.38,24-6.68,36.6h-27.52Zm49.1-115.5-1.63-.28c-3.31,20.33-6.62,40.67-9.95,61.15h21.44C1099.46,546.85,1096.21,526.77,1093,506.69Z"
      fill="#fff"
    />
    <Path
      d="M922.69,356.66V192.52h68.44v21.27H953.26v46.69h29.9v21.46h-30v53.75h38.49v21Z"
      fill="#fff"
    />
    <Path d="M912.78,192.31v21.1H876.21v47h29v21.52H875.86v74.61H845.58V192.31Z" fill="#fff" />
    <Path
      d="M1043.86,622.19l.05,2.85H972.57V461.51h29.55V604.13h38.11C1041.55,610.7,1042.71,616.44,1043.86,622.19Z"
      fill="#fff"
    />
    <Path d="M746.69,336h38.86v20.62H717.14V192.45h29.55Z" fill="#fff" />
    <Path d="M825.78,356.76H796.85V192.46h28.93Z" fill="#fff" />
  </SVG>
);
